import store from "../store";
// import apiFactory from "../services/apiFactory";

const actions = {
  // getAppSettings() {
  //   apiFactory.$_getAppSettings().then((response) => {
  //     store.commit("UPDATE_APP_SETTINGS", response.data.appSettings);
  //   });
  // },
  toggleSideNav() {
    store.commit("UPDATE_SIDENAV_STATE");
  },
  resetUserList() {
    store.commit("RESET_USER_LIST");
  },
  resetAllGroups() {
    store.commit("RESET_ALL_GROUPS");
  },
  showToast({ commit }, payload) {
    commit("SET_TOAST_OPTIONS", payload);
    setTimeout(() => {
      commit("RESET_TOAST");
    }, 6000);
  },
  resetToast({ commit }) {
    commit("RESET_TOAST");
  },
};
export default actions;
